import React, { useCallback } from 'react';
import * as Styles from './ProjectsBar.styles';
import withErrorBoundary from '@/utils/errorBoundary';
import { IconMagicPen } from '../Icons/IconMagicPen';
import { IconFolder } from '../Icons/IconFolder';
import useLocale from '@/hooks/useLocale';
import ButtonCreateSiteAi from '../HighlightFeatures/ButtonCreateSiteAi/ButtonCreateSiteAi';
import { useStudio } from '@/hooks/studio';
import { studioAnalytics } from '@/analytics/studio';

const ProjectsBar = ({ isProPlan }) => {
  const { studio: studioLocale } = useLocale();
  const { openStudio } = useStudio();

  const handleProjectsClick = useCallback(() => {
    studioAnalytics.projectsClick();
    openStudio('documents_history');
  }, [openStudio]);

  if (isProPlan) {
    return null;
  }

  return (
    <Styles.Wrapper data-testid="projects-bar">
      <Styles.Button
        data-testid="manage-design-button"
        active
      >
        <IconMagicPen />
        {studioLocale.topBanner.design}
      </Styles.Button>

      <Styles.Button
        data-testid="manage-projects-button"
        onClick={() => handleProjectsClick()}
      >
        <IconFolder />
        {studioLocale.topBanner.projects}
      </Styles.Button>

      <ButtonCreateSiteAi position="bottom" />
    </Styles.Wrapper>
  );
};

export default withErrorBoundary(ProjectsBar, 'ProjectsBar');
